const aosConfig = {
  offset: 200,
  once: true,
  delay: 200,
  duration: 400
};

export default aosConfig;
